'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _UIAlert = require('UIComponents/alert/UIAlert');

var _UIAlert2 = _interopRequireDefault(_UIAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PromotionBanner = function PromotionBanner(_ref) {
  var promotion = _ref.promotion,
      titleText = _ref.titleText,
      bodyText = _ref.bodyText,
      dataSelenium = _ref.dataSelenium,
      hasTitleComponent = _ref.hasTitleComponent;

  (0, _react.useEffect)(function () {
    var name = promotion.toLowerCase() + ' promotion banner';
    (0, _getUsageTracker2.default)().track('bannerInteraction', { name: name });
  }, []);

  return _react2.default.createElement(
    'div',
    { className: hasTitleComponent ? 'm-bottom-8' : 'm-top-12' },
    _react2.default.createElement(
      _UIAlert2.default,
      {
        'data-selenium': dataSelenium,
        className: 'm-y-2',
        titleText: titleText,
        type: 'info'
      },
      _react2.default.createElement(
        'p',
        { className: 'm-y-0 m-right-3' },
        bodyText
      )
    )
  );
};

PromotionBanner.propTypes = {
  promotion: _react.PropTypes.string.isRequired,
  hasTitleComponent: _react.PropTypes.bool.isRequired,
  titleText: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]).isRequired,
  bodyText: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]),
  dataSelenium: _react.PropTypes.string
};

exports.default = PromotionBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/banners/PromotionBanner.js
// module id = 725
// module chunks = 3 4